<div id="mainComponentContainer">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="pointsToRedeemHeadings" :data="pointsToRedeem" :hasActions="true"
                                :hasNoFilter="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onPointsToEarnActionClicked">
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <modal-form
            :heading="editPointsToRedeemModal.heading"
            :modalId="editPointsToRedeemModal.modalId"
            :isSaving="editPointsToRedeemModal.isSaving"
            :showModal="editPointsToRedeemModal.showModal"
            @closeClicked="onEditPointsToRedeemPerCentsValueModalCloseClick"
            @saveButtonClicked="onEditPointsToRedeemPerCentsValueModalSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label>
                        Cents Value
                    </label>
                    <div class="text-danger" v-if="editPointsToRedeemModal.centsValue.hasError">
                        {{editPointsToRedeemModal.centsValue.errorMessage}}
                    </div>
                    <currency-input class="form-control" v-model="editPointsToRedeemModal.centsValue.value"
                                    :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"
                                    ></currency-input>
                </div>
                <div class="form-group">
                    <label>
                        Points To Redeem Per Cents Value
                    </label>
                    <div class="text-danger" v-if="editPointsToRedeemModal.pointsRedeemablePerCentsValue.hasError">
                        {{editPointsToRedeemModal.pointsRedeemablePerCentsValue.errorMessage}}
                    </div>
                    <input type="number" class="form-control" v-model="editPointsToRedeemModal.pointsRedeemablePerCentsValue.value">
                </div>
            </form>
        </template>
    </modal-form>
    
</div>
